import { SidebarContent } from "@repo/ui/ui/sidebar";
import { useRouterState } from "@tanstack/react-router";

import { SidebarHome } from "./sidebar-home";
import { SidebarSettings } from "./sidebar-settings";

export const AppSidebarContent = () => {
  const isSettingsPage = useRouterState({
    select: (s) => s.location.pathname.startsWith("/settings"),
  });

  return (
    <SidebarContent className="[-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
      {isSettingsPage ? <SidebarSettings /> : <SidebarHome />}
    </SidebarContent>
  );
};
